import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@fullstory/components';
import css from './titleLink.module.scss';

interface TitleLinkProps {
  to: React.ComponentProps<typeof Link>['to'] | undefined;
  /**
   * When provided, an external link is used opening in a new tab instead.
   */
  href?: string;
}

/** Link with routing disabled on drag-and-drop.
 *  Necessary to ensure home cards don't route when drag-and-dropping from title. */
export const TitleLink: React.FC<PropsWithChildren<TitleLinkProps>> = ({ to, href, children }) => {
  if (href) {
    return (
      <a className={css.noUnderline} href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  } else if (to) {
    return (
      <Link className={css.noUnderline} to={to} href={href}>
        {children}
      </Link>
    );
  } else {
    return <Box>{children}</Box>;
  }
};
